import {IdPrefix} from './idHelpers.enums';

/**
 * All known prefixes sorted longest-first so greedy matching works correctly.
 * e.g. CARD before CF, PSET before PSTR before PF, CTI before CRT before CF, CSET before CSTR
 */
export const allIdPrefixes: IdPrefix[] = Object.values(IdPrefix).sort(
  (a, b) => b.length - a.length,
);

export const feedIdPrefixes = [IdPrefix.ProductFeed, IdPrefix.LocationFeed, IdPrefix.ContentFeed];

export const strategyIdPrefixes = [
  IdPrefix.ProductStrategy,
  IdPrefix.LocationStrategy,
  IdPrefix.ContentStrategy,
];
